import { all } from 'redux-saga/effects';

import eventosEspeciais from './eventosEspeciais/saga';

export default all([eventosEspeciais]);
